module.exports = __webpack_public_path__ + "img/neobank.411f5b39.png";